/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumRichiestaDTOStato =
  (typeof EnumRichiestaDTOStato)[keyof typeof EnumRichiestaDTOStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumRichiestaDTOStato = {
  CREATA: 'CREATA',
  BOZZA: 'BOZZA',
  IN_INVIO: 'IN_INVIO',
  INVIATA: 'INVIATA',
  INTEGRATA: 'INTEGRATA',
  CANCELLATA: 'CANCELLATA',
  RICEVUTA: 'RICEVUTA',
  CONCLUSA: 'CONCLUSA',
  PAGAMENTO: 'PAGAMENTO',
  ANNULLATA: 'ANNULLATA',
  ANNULLAMENTO_IN_CORSO: 'ANNULLAMENTO_IN_CORSO',
} as const;
